<template>
  <div class="newList">
    <!-- 新自助查询缴费组件 -->
    <van-radio-group v-model="select">
      <div class="form" v-for="(item, index) in dataList" :key="index">
        <div class="title">
          <div class="tLeft">
            <van-checkbox
              v-if="
                (item.isConfirm == 0 ||
                  item.isConfirm == 9 ||
                  item.isConfirm == 2 ||
                  item.isConfirm == 3) &&
                  hideCheckBox != true
              "
              shape="square"
              v-model="item.checked"
              @click="handleSelect(item)"
            ></van-checkbox>
            <span
              :style="
                !(
                  item.isConfirm == 0 ||
                  item.isConfirm == 9 ||
                  item.isConfirm == 2 ||
                  item.isConfirm == 3
                )
                  ? 'margin-left:0px;'
                  : ''
              "
              >NO: {{ item.noticeNo }}</span
            >
          </div>
          <div
            :class="[
              'paySta',
              item.refundStatus == '100'
                ? 'bfRefund'
                : item.refundStatus == '200'
                ? 'allRefund'
                : item.isConfirm == '1'
                ? 'Suc'
                : item.isConfirm == '9'
                ? 'Paying'
                : ''
            ]"
          >
            <!-- {{
              item.isConfirm == "0"||item.isConfirm == "2"||item.isConfirm == "3"
                ? "未支付"
                : item.isConfirm == "1"
                ? "已支付"
                : item.isConfirm == "9"
                ? "支付中"
                : ""
            }} -->
          </div>
        </div>
        <div
          class="contentbox"
          :class="[item.tradingType == '12' ? 'free' : '']"
        >
          <div class="ctbox">
            <span>执收单位：</span>
            <span>{{ item.deptName }}</span>
          </div>
          <div class="ctbox">
            <span v-if="!item.hasName">缴款单位/人：</span>
            <span v-else>
              <span v-if="item.showFieldList2&&item.showFieldList2.length>0&&isHistory!='1'">
                <span :key="index" v-show="i.fieldName=='paymentUnit'||i.fieldName=='name'" v-for="(i,index) in item.showFieldList2">
                {{ i.showName }}：
              </span>
              </span>
              <span v-else>
                <span :key="index" v-show="i.fieldName=='paymentUnit'||i.fieldName=='name'" v-for="(i,index) in item.showFieldList">
                {{ i.showName }}：
              </span>
              </span>

            </span>
            <span>{{ item.paymentUnit }}</span>
          </div>
          <div class="ctbox">
            <span v-if="!item.hasIdCard">证件号码：</span>
            <span v-else>
              <span v-if="item.showFieldList2&&item.showFieldList2.length>0&&isHistory!='1'">
                <span :key="index" v-show="i.fieldName=='idCard'" v-for="(i,index) in item.showFieldList2">
                {{ i.showName }}：
              </span>
              </span>
              <span v-else>
                <span :key="index" v-show="i.fieldName=='idCard'" v-for="(i,index) in item.showFieldList">
                {{ i.showName }}：
              </span>
              </span>
            </span>
            <span>{{ item.idCard ? item.idCard : "未录入" }}</span>
          </div>
          <div class="money ctbox">
            <span>缴款金额：</span>
            <span>¥ {{ item.paymentTotal }}</span>
          </div>
          <div class=" ctbox" v-if="item.isConfirm == 1">
            <span>缴款时间：</span>
            <span>{{ item.confirmDate }}</span>
          </div>
          <div class="remark">
            <span v-if="!item.hasRemark">备<span>证件</span>注：</span>
            <span v-else>
              <b style="font-weight:400;display: flex;" v-if="item.showFieldList2&&item.showFieldList2.length>0&&isHistory!='1'">
                <b :class="i.fieldName=='remark'&&i.showName.length<3?'remark_special':''" style="font-weight:400;" :key="index" v-show="i.fieldName=='remark'" v-for="(i,index) in item.showFieldList2">
                <b style="font-weight:400;" :key="im" v-for="(im) in i.showName">{{ im }}</b>
                </b>：
            </b>

              <b style="font-weight:400;display: flex;" v-else>
                <b :class="i.fieldName=='remark'&&i.showName.length<3?'remark_special':''" style="font-weight:400;" :key="index" v-show="i.fieldName=='remark'" v-for="(i,index) in item.showFieldList">
                  <b style="font-weight:400;" :key="im" v-for="(im) in i.showName">{{ im }}</b>
                </b>：
              </b>
            </span>
            <div
              v-if="item.remark"
              class="remarkWord"
              @click="handleRemark(item.remark)"
            >
              <span>
                {{ item.remark }}
              </span>
            </div>
            <span v-else>无</span>
          </div>
          <!-- <img
            :src="require('@/assets/img/confirm' + item.isConfirm + '.png')"
            alt
          /> -->
        </div>
        <div :class="[item.countFlag ? 'cu-form-gro' : 'cu-form-group']">
          <van-popover
            :get-container="getContainer"
            v-model="item.showPopover"
            trigger="click"
            :actions="item.actions"
            @open="selItem(item)"
            @select="onSelect"
            placement="bottom-start"
          >
            <template #reference>
              <div v-if="item.countFlag" class="moreBtn">更多</div>
            </template>
          </van-popover>
          <div @click="handleDetail(item, index)">查看详情</div>
          <div
            v-if="
              isTicket &&
                item.actions &&
                !item.actions.some(it => {
                  return it.text == '打印小票';
                })
            "
            @click="printNotice(index)"
          >
            打印小票
          </div>
          <div
            v-if="
              isSelfQ &&
                item.isConfirm == '1' &&
                item.showRefund == '1' &&
                item.actions &&
                !item.actions.some(it => {
                  return it.text == '申请退费';
                })
            "
            @click="handleRefund(item)"
          >
            申请退费
          </div>

          <div
            @click="showTDia(item)"
            v-if="
              item.isConfirm != '1' &&
                !(item.dataSource == '7' && item.isConfirm == '1') &&
                item.billEnable &&
                item.actions &&
                !item.actions.some(it => {
                  return it.text == '开票信息';
                })
            "
          >
            开票信息
          </div>
          <div
            v-if="
              item.manual &&
                item.isConfirm == 1 &&
                item.isETicket == true &&
                item.actions &&
                !item.actions.some(it => {
                  return it.text == '开具电子票';
                })
            "
            @click="openEticket(item)"
          >
            开具电子票
          </div>
          <div
            v-else-if="
              item.manual == false &&
                item.isConfirm == 1 &&
                item.isETicket == true &&
                item.actions &&
                !item.actions.some(it => {
                  return it.text == '查看电子票';
                })
            "
            @click="getEticket(item)"
          >
            查看电子票
          </div>
          <div
              v-else-if="item.showPrint"
              @click="printPaymentSlip(item)"
          >
            打印缴费单
          </div>
          <!-- <div v-else-if="item.isConfirm == 1 && item.isETicket == false">
            {{ item.payCode }}
          </div>-->
        </div>
      </div>
    </van-radio-group>
    <!-- <div class="dialog">
      <van-dialog
        v-model="show"
        title="开票信息"
        show-cancel-button
        @open="regetMsg"
        @confirm="saveTicket"
        :show-confirm-button="currentValue.isConfirm == '0'"
      >
        <van-form>
          <div v-if="tKeys.length > 0">
            <van-field
              v-for="(it, index) in tKeys"
              :key="index"
              v-model="currentValue[it]"
              :label="ticketList[it]"
              :disabled="currentValue.isConfirm == '1'"
              :placeholder="
                currentValue.isConfirm == '1' ? '' : '请输入' + ticketList[it]
              "
            />
          </div>
        </van-form>
      </van-dialog>
    </div> -->
    <ErrDialog :show="showErr" :notice="errCon" @close="closeErr"></ErrDialog>
    <!-- <PayBill :show="show" :tKeys="tKeys" :ticketList="ticketList" :billInfo="currentValue"></PayBill> -->
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import ErrDialog from "@/components/dialog/errorNotice";
import PayBill from "@/views/selfPayNew/payBillInfo";
import { Popover } from "vant";
import {isUrl} from "@/utils/common";
export default {
  props: [
    "isSelfQ",
    "isFromTy",
    "dataList",
    "isTicket",
    "checkedMark",
    "showDetailMsg",
    "isMerge",
    "hideCheckBox",
    "checkedAll",
    "afAction",
    "fromType",
    "active",
    "isTYSM"
  ],
  components: {
    ErrDialog,
    PayBill
  },
  watch: {
    dataList: {
      handler(val) {
        if (val.length > 0) {
          setTimeout(() => {
            this.dataList.forEach((val, index) => {
              let actions = [{ text: "查看详情" }];
              if (this.isTicket) {
                actions.push({
                  text: "打印小票"
                });
              }
              if (
                val.isConfirm != "1" &&
                !(val.dataSource == "7" && val.isConfirm == "1") &&
                val.billEnable
              ) {
                actions.push({
                  text: "开票信息"
                });
              }
              if (val.manual && val.isConfirm == 1 && val.isETicket == true) {
                actions.push({
                  text: "开具电子票"
                });
              }
              if (
                val.manual == false &&
                val.isConfirm == "1" &&
                val.isETicket == true
              ) {
                actions.push({
                  text: "查看电子票"
                });
              }
              if (val.isConfirm == 1) {
                actions.push({
                  text: "申请退费"
                });
              }
              this.sysType = val.sysType;
              this.$set(val, "countFlag", false);
              // this.$set(val, "showPopover", false);
              if (actions.length > 3) {
                this.$set(val, "countFlag", true);
                actions = actions.slice(3);
              } else {
                actions = [];
              }
              this.$set(val, "actions", actions);
            });
          });
        }
      },
      deep: true
    },
    // afAction(val) {
    //   if (val == "1") {
    //     try {
    //       // console.log(222);
    //       // console.log(this.checkArr);
    //       // this.checkArr=[];
    //       if (this.checkArr.length == 1 && this.dataList.length == 1) {
    //       } else {
    //         if (this.checkArr.length > 0&& this.checkArr.length<this.dataList.length) {
    //           this.alreadyCheck = JSON.parse(JSON.stringify(this.checkArr));
    //           this.checkArr = [];
    //           console.log(111)
    //           // console.log(this.alreadyCheck);
    //           // console.log(this.dataList);
    //           for (var i = 0; i < this.dataList.length; i++) {
    //             this.handleSelect(this.dataList[i], true);
    //           }

    //         } else if(this.checkArr.length == 0){
    //           // console.log(123);
    //           // console.log(this.checkArr);
    //           console.log(222)
    //           this.checkArr = [];
    //           this.alreadyCheck = [];
    //           for (var i = 0; i < this.dataList.length; i++) {
    //             this.handleSelect(this.dataList[i], true);
    //           }
    //         }
    //       }
    //     } catch (e) {}
    //   } else {
    //     console.log(123)
    //     // if(this.alreadyCheck.length>0){

    //     // }else{
    //     //   this.checkArr = [];
    //     //   this.alreadyCheck = [];
    //     //   this.dataList.forEach((val, index) => {
    //     //     this.$set(val, "checked", false);
    //     //   });
    //     //   this.$emit("checkArr", this.checkArr);
    //     // }

    //     // this.$emit('resetAction');
    //   }
    // }
  },
  // updated(){
  //       this.dataList.forEach((val, index) => {
  //         let actions = [{ text: "查看详情" }];
  //         if (this.isTicket) {
  //           actions.push({
  //             text: "打印小票",
  //           });
  //         }
  //         if (
  //           val.isConfirm != "1" &&
  //           !(val.dataSource == "7" && val.isConfirm == "1") &&
  //           val.billEnable
  //         ) {
  //           actions.push({
  //             text: "开票信息",
  //           });
  //         }
  //         if (val.manual && val.isConfirm == 1 && val.isETicket == true) {
  //           actions.push({
  //             text: "开具电子票",
  //           });
  //         }
  //         if (val.manual == false && val.isConfirm == '1' && val.isETicket == true) {
  //           actions.push({
  //             text: "查看电子票",
  //           });
  //         }
  //         if (val.isConfirm == 1) {
  //           actions.push({
  //             text: "申请退费",
  //           });
  //         }
  //         if (val.uId == this.checkedMark) {
  //           this.select = index;
  //           this.$set(val, "checked", true);
  //           this.checkArr.push(val);
  //         } else {
  //           this.$set(val, "checked", false);
  //         }
  //         this.sysType = val.sysType;
  //         this.$set(val, "countFlag", false);
  //         this.$set(val, "showPopover", false);
  //         if (actions.length > 3) {
  //           this.$set(val, "countFlag", true);
  //           actions=actions.slice(3,)
  //         }else{
  //           actions=[];
  //         }
  //         this.$set(val, "actions", actions);
  //       });
  // },
  data() {
    return {
      vList: [],
      // 通过 actions 属性来定义菜单选项
      alreadyCheck: [],
      showErr: false,
      errCon: "",
      sysType: 0,
      ticketList: {},
      tKeys: [], // 保存票据信息的keys
      show: false,
      showModel: false,
      idx: 0,
      select: -1,
      checkArr: [],
      currentValue: {},
      oldValue: {},
      selObj: null,
      detailList: []
    };
  },

  created() {
    this.dataList.forEach((val, index) => {
      let actions = [{ text: "查看详情" }];
      if (this.isTicket) {
        actions.push({
          text: "打印小票"
        });
      }
      if (
        val.isConfirm != "1" &&
        !(val.dataSource == "7" && val.isConfirm == "1") &&
        val.billEnable
      ) {
        actions.push({
          text: "开票信息"
        });
      }
      if (val.manual && val.isConfirm == 1 && val.isETicket == true) {
        actions.push({
          text: "开具电子票"
        });
      }
      if (
        val.manual == false &&
        val.isConfirm == "1" &&
        val.isETicket == true
      ) {
        actions.push({
          text: "查看电子票"
        });
      }
      if (val.isConfirm == 1) {
        actions.push({
          text: "申请退费"
        });
      }
      if (val.uId == this.checkedMark) {
        this.select = index;
        this.$set(val, "checked", true);
        this.checkArr.push(val);
      } else {
        this.$set(val, "checked", false);
      }
      this.sysType = val.sysType;
      this.$set(val, "countFlag", false);
      this.$set(val, "showPopover", false);
      if (actions.length > 3) {
        this.$set(val, "countFlag", true);
        actions = actions.slice(3);
      } else {
        actions = [];
      }
      if(val.showFieldList&&val.showFieldList.length>0){
        val.showFieldList.forEach(i=>{
          if(i.fieldName=='name'||i.fieldName=='paymentUnit'){
            this.$set(val,'hasName',true)
          }
          if(i.fieldName=='idCard'){
            this.$set(val,'hasIdCard',true)
          }
          if(i.fieldName=='remark'){
            this.$set(val,'hasRemark',true)
          }
        })
      }
      // if(val.showFieldList2&&val.showFieldList2.length>0){
      //   this.$set(val,'hasName',false)
      //   this.$set(val,'hasIdCard',false)
      //   this.$set(val,'hasRemark',false)
      //   val.showFieldList2.forEach(i=>{
      //     if(i.fieldName=='name'||i.fieldName=='paymentUnit'){
      //       this.$set(val,'hasName',true)
      //     }
      //     if(i.fieldName=='idCard'){
      //       this.$set(val,'hasIdCard',true)
      //     }
      //     if(i.fieldName=='remark'){
      //       this.$set(val,'hasRemark',true)
      //     }
      //   })
      // }
      this.$set(val, "actions", actions);
      this.$emit("checkArr", this.checkArr);
    });
    // 自助查询缴费,默认选中一条未支付数据
    if (this.fromType == "1" && this.dataList.length == 1) {
      this.$set(this.dataList[0], "checked", true);
      this.checkArr = [this.dataList[0]];
      this.$emit("checkArr", this.checkArr);
    }
    this.vList = JSON.parse(JSON.stringify(this.dataList));
  },
  methods: {
    printPaymentSlip(item){
      this.$router.push({
        path:'/print/paymentSlip',
        query:{
          noticeNo:item.noticeNo,
          fullPath:this.$route.fullPath
        }
      })
    },
    selItem(item) {
      this.selObj = item;
    },
    handleRefund(item) {
      this.$emit("refundAction", item);
    },
    getContainer() {
      return document.querySelector(".newList");
    },
    onSelect(act) {
      // item
      // console.log(act);
      // Toast(act.text);
      if (act.text == "开票信息") {
        this.showTDia(this.selObj);
      }
      if (act.text == "开具电子票") {
        this.openEticket(this.selObj);
      }
      if (act.text == "查看电子票") {
        this.getEticket(this.selObj);
      }
      if (act.text == "申请退费") {
        this.handleRefund(this.selObj);
      }
    },
    closeErr() {
      this.showErr = false;
    },
    regetMsg() {
      this.currentValue = JSON.parse(JSON.stringify(this.currentValue));
    },
    saveTicket() {
      let data = {};
      data.uId = this.currentValue.uId;
      this.tKeys.forEach(it => {
        data[it] = this.currentValue[it];
      });
      if (this.isTYSM) {
        data.isGeneral = "1";
      }
      data.sysType = this.sysType;
      this.request({
        url: "/mobile/updateEduBizDateBill",
        method: "post",
        params: data
      }).then(res => {
        if (res.data.code == 1000) {
        } else {
        }
        this.$emit("reget");
      });
    },
    showTDia(val) {
      // if(this.flag){
      // this.oldValue = JSON.parse(JSON.stringify(val));
      // this.flag=false;
      // }

      this.currentValue = val;
      // console.log(val);
      localStorage.setItem("currentValue", JSON.stringify(val));
      if (this.isFromTy == 1) {
        this.$router.push({
          path: "/bussiess/payBillInfo",
          query: {
            dataType: val.dataType,
            deptId: val.deptId,
            uId: val.uId
          }
        });
      } else {
        this.$router.push({
          path: "/payBillInfo",
          query: {
            dataType: val.dataType,
            deptId: val.deptId,
            uId: val.uId
          }
        });
      }
      // console.log(this.oldValue);
      // this.getTicketMess(val);
    },
    getTicketMess(it) {
      this.request({
        url: "/business/getH5BillField",
        method: "post",
        params: {
          dataType: it.dataType,
          deptId: it.deptId
        }
      }).then(res => {
        if (res.data.code == 1000) {
          if (res.data.result) {
            this.ticketList = res.data.result;

            if (this.tKeys.length > 0) {
              this.tKeys.forEach(it => {
                if (this.currentValue[it] == undefined) {
                  delete this.currentValue[it];
                }
              });
            }
            this.tKeys = Object.keys(this.ticketList);

            for (var i in res.data.result) {
              if (!this.currentValue[i]) {
                this.$set(this.currentValue, i, "");
              }
            }
            this.show = true;
          } else {
            // this.showErr = true;
            // this.errCon = "票据信息为空";
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              message: "票据信息为空"
            });
          }
        } else {
          let str = "确认";
          if (res.data.errorMessage) {
            str = "查看错误详情";
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message
            }).then(() => {
              this.$CTips({
                title: "错误提示",
                message: res.data.errorMessage,
                clickOverlay: false
              });
            });
          } else {
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message
            });
          }
          // if (!res.data.errorMessage) {
          //   // Dialog.alert({
          //   //   title: "提示",
          //   //   message: res.data.message
          //   // }).then(() => {});
          // }
        }
      });
    },
    getTicket(it) {
      this.request({
        url: "/business/getH5BillField",
        method: "post",
        params: {
          dataType: it.dataType,
          deptId: it.deptId
        }
      }).then(res => {
        if (res.data.code == 1000) {
          if (res.data.result) {
            this.$set(it, "showTick", true);
          }
        } else {
          if (!res.data.errorMessage) {
            Dialog.alert({
              title: "提示",
              message: res.data.message
            }).then(() => {});
          }
        }
      });
    },
    // 详细信息（教育）
    handleDetail(item, index) {
      this.showModel = true;
      this.$emit("handleDetail", item);
    },
    // 选择要支付的信息
    handleSelect(selectItem, val) {
      // console.log(selectItem);
      if (val == true) {
        selectItem.checked = true;
      }
        this.checkArr=[];
        // console.log(this.dataList)
        let arr=JSON.parse(JSON.stringify(this.dataList));
        this.checkArr=[];
        if (arr.length > 0) {
          arr.forEach(item=>{
            if(item.checked){
              this.checkArr.push(item)
            }
          })
        }
      // console.log(this.checkArr)
      // if(this.checkArr.length==0||(this.checkArr.length>0&&this.checkArr.length<this.dataList.length)){
      //   // 修改afAction的值
      //   this.$emit("changeAction", '2');
      // }else{
      //   this.$emit("changeAction", '1');
      // }
      this.$forceUpdate();
      this.$emit("checkArr", this.checkArr);
    },

    // 2.0合并支付
    merge(item) {
      let selectArr = {};
      if (this.checkArr && this.checkArr.length > 0) {
        this.checkArr.forEach(val => {
          if (val.deptId != item.deptId) {
            item.checked = false;
            // Dialog.alert({
            //   title: "提示",
            //   message: "执收单位不同，不能合并支付",
            // }).then(() => {});
            // this.showErr = true;
            // this.errCon = "执收单位不同，不能合并支付";
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              message: "执收单位不同，不能合并支付"
            });
            this.dataList.forEach((val, index) => {
              this.alreadyCheck.forEach(item => {
                if (val.uId == item.uId) {
                  val.checked = true;
                }
              });
            });
            // this.$emit('resetAction');
            this.$emit("checkArr", this.alreadyCheck);
          } else if (
            val.billInterfaceType != item.billInterfaceType ||
            (val.billInterfaceType != 1 &&
              val.billInterfaceType != 2 &&
              val.billInterfaceType != 4)
          ) {
            // billInterfaceType相等且billInterfaceType为1,2,4时才支持合并支付
            item.checked = false;
            // Dialog.alert({
            //   title: "提示",
            //   message: "当前不允许合并支付",
            // }).then(() => {});
            // this.showErr = true;
            // this.$emit('resetAction');
            // console.log(this.alreadyCheck);
            this.dataList.forEach((val, index) => {
              this.alreadyCheck.forEach(item => {
                if (val.uId == item.uId) {
                  val.checked = true;
                }
              });
            });
            this.$emit("checkArr", this.alreadyCheck);
            // this.errCon = "当前不允许合并支付";
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              message: "当前不允许合并支付"
            });
          } else {
            selectArr = item;
          }
        });
      } else {
        selectArr = item;
      }
      if (selectArr.uId) {
        this.checkArr.push(selectArr);
      }
    },

    // 查看电子票
    getEticket(item) {
      if (item.dataSource == "6") {
        // Dialog.alert({
        //   title: "提示",
        //   message: "该数据为使用系统前的历史缴费数据，不能查看票据信息",
        // }).then(() => {});
        // this.showErr = true;
        // this.errCon = "该数据为使用系统前的历史缴费数据，不能查看票据信息";
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          message: "该数据为使用系统前的历史缴费数据，不能查看票据信息"
        });
        return;
      }
      if (
        item.merchantType == "001" ||
        item.merchantType == "002" ||
        item.merchantType == "003" ||
        item.merchantType == "004" ||
        item.merchantType == "015" ||
        item.merchantType == "016" ||
        item.merchantType == "017"
      ) {
        let data = {
          bizId: item.uId,
          sysType: item.sysType
        };
        this.request({
          baseURL: process.env.VUE_APP_PAY_URL,
          url: "/merger/show_ticket",
          method: "post",
          data: data
        }).then(res => {
          if (res.data.code == 1000) {
            // window.location.href=res.data.message;
            var device = navigator.userAgent;
            var isiOS = !!device.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (res.data.result.einvoiceUrl) {
              //ios终端
              let prefix = res.data.result.einvoiceUrl.slice(0, 5);
              if (prefix === "https") {
                this.$router.push({
                  path:
                    "/eTicket?url=" +
                    encodeURIComponent(res.data.result.einvoiceUrl)
                });
                // &&isiOS
              } else if (prefix != "https") {
                window.location.href = res.data.result.einvoiceUrl;
              }
              // else{
              //   this.$router.push({
              //     path: "/eTicket?url=" + encodeURIComponent(res.data.result.einvoiceUrl),
              //   });
              // }

              // this.$router.push({
              //   path:
              //     "/eTicket?url=" +
              //     encodeURIComponent(res.data.result.einvoiceUrl),
              // });
            } else {
              // Toast("暂未返回电子票信息");
              this.$CDialog({
                confirmBtnText: "确认",
                title: "提示",
                status: "2",
                textSize: 16,
                message: "暂未返回电子票信息"
              }).then(res => {});
            }
          } else {
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message: res.data.message
            }).then(res => {});
            // Toast(res.data.message);
          }
        });
      } else {
        let data = {};
        data.bizId = item.uId;
        data.noticeNo = item.noticeNo;
        data.billInterfaceType = item.billInterfaceType;
        data.sysType = item.sysType == 1 ? "1" : "2";
        if (item.sysType == "1") {
          this.getFundsNature(item.uId).then(res => {
            // 只有一条电子票票的情况
            this.$emit("ticketArr", res, data);
          });
        } else {
          this.request({
            baseURL: process.env.VUE_APP_PAY_URL,
            url: "/pay/showETicket",
            method: "post",
            data: data
          }).then(res => {
            if (res.data.code == 1000) {
              // window.location.href=res.data.message;

              if (!res.data.message) {
                this.$CDialog({
                  confirmBtnText: "确认",
                  title: "提示",
                  status: "2",
                  textSize: 16,
                  message: "返回票据信息有空，请刷新后重试"
                }).then(res => {});
              } else {
                // this.$router.push({
                //   path: "/eTicket?url=" + encodeURIComponent(res.data.message)
                // });
                let result = isUrl(res.data.message);
                if (result !== null) {
                  this.$router.push({
                    path: '/eTicket?url=' + encodeURIComponent(res.data.message),
                  });
                } else {
                  this.$store.commit('notice/setPicture', res.data.message);
                  this.$router.push({
                    path:'/eTicketPicture'
                  })
                }
              }
            } else {
              this.$CDialog({
                confirmBtnText: "确认",
                title: "提示",
                status: "2",
                textSize: 16,
                message: res.data.message
              }).then(res => {});
              // Toast(res.data.message);
            }
          });
        }
      }
    },

    // 查看资金性质(教育查看电子票先调这个)
    getFundsNature(bizId) {
      return new Promise(resolve => {
        this.request({
          url: "/edu/queryTicket",
          method: "get",
          params: { bizId: bizId }
        }).then(res => {
          if (res.data.code == 1000) {
            resolve(res.data.result);
          } else {
            // Toast(res.data.message);
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message: res.data.message
            }).then(res => {});
          }
        });
      });
    },
    // 开具电子票
    openEticket(row) {
      if (row.billInterfaceType != 0) {
        // Dialog.alert({
        //   title: "提示",
        //   message: "该功能只支持全国标准版！",
        // }).then(() => {});
        // this.showErr = true;
        // this.errCon = "该功能只支持全国标准版！";
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          message: "该功能只支持全国标准版！"
        });
        return;
      }
      if (row.batchModel == "5") {
        // Dialog.alert({
        //   title: "提示",
        //   message: "数据为汇总数据，不能查看票据",
        // }).then(() => {});
        // this.showErr = true;
        // this.errCon = "数据为汇总数据，不能查看票据";
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          message: "数据为汇总数据，不能查看票据"
        });
        return;
      }
      if (row.isConfirm != "1") {
        // Dialog.alert({
        //   title: "提示",
        //   message: "该数据未缴费不能查看票据",
        // }).then(() => {});
        // this.showErr = true;
        // this.errCon = "该数据未缴费不能查看票据";
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          message: "该数据未缴费不能查看票据"
        });
        return;
      }
      if (row.dataSource == "6") {
        // Dialog.alert({
        //   title: "提示",
        //   message: "该数据为使用系统前的历史缴费数据，不能查看票据信息",
        // }).then(() => {});
        // this.showErr = true;
        // this.errCon = "该数据为使用系统前的历史缴费数据，不能查看票据信息";
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          message: "该数据为使用系统前的历史缴费数据，不能查看票据信息"
        });
        return;
      }
      this.request({
        url: "/manual/invoice_none",
        method: "post",
        data: {
          bizId: row.uId,
          dataType: row.dataType,
          sysType: row.sysType
        }
      }).then(res => {
        if (res.data.code == 1000) {
          if (res.data.result.einvoiceUrl) {
            // window.open(res.data.result.einvoiceUrl);
            window.location.href = res.data.result.einvoiceUrl;
          } else {
            // Dialog.alert({
            //   title: "提示",
            //   message: "暂无电子票据",
            // }).then(() => {});
            // this.showErr = true;
            // this.errCon = "暂无电子票据";
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              message: "暂无电子票据"
            });
          }
        } else {
          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // // }).then(() => {});
          // this.showErr = true;
          // this.errCon = res.data.message;
          let str = "确认";
          if (res.data.errorMessage) {
            str = "查看错误详情";
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message
            }).then(() => {
              this.$CTips({
                title: "错误提示",
                message: res.data.errorMessage,
                clickOverlay: false
              });
            });
          } else {
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message
            });
          }
        }
      });
    },

    printNotice(index) {
      this.$emit("printNotice", index);
    },
    handleRemark(item) {
      if (item && item.length > 13) {
        // Dialog.alert({
        //   title: "备注",
        //   message: item,
        // }).then(() => {});
        // this.showErr = true;
        // this.errCon = item;
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          message: item
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.moreBtn {

  font-size: 14px;
  color: #7e7e7e;
  letter-spacing: -1.3px;
  text-align: center;
  font-weight: 400;
}
.newList {
  // box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  ::v-deep .van-popover__action-text {
    justify-content: flex-start;
  }
}
.form {
  border-radius: 2px;
  box-sizing: border-box;
  background-color: #fff;
  margin: 0 auto;
  box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
  border-radius: 10px;
  margin-bottom: 10px;
  // padding: 0 20px;
  width: 345px;
  .paySta {
    //
    // font-size: 18px;
    // color: #f46c6c;
    // letter-spacing: 0;
    // text-align: right;
    // font-weight: 700;
    position: absolute;
    background: url("../assets/img/notPay.png") no-repeat;
    background-size: cover;
    top: -2px;
    right: 11px;
    width: 46px;
    height: 41px;
  }
  .paySta.Suc {
    background: url("../assets/img/alreadyPay.png") no-repeat;
    background-size: cover;
  }
  .paySta.Paying {
    background: url("../assets/img/inPay.png") no-repeat;
    background-size: cover;
  }
  .bfRefund {
    background: url("../assets/img/bftk.png") no-repeat;
    background-size: cover;
  }
  .allRefund {
    background: url("../assets/img/alltk.png") no-repeat;
    background-size: cover;
  }
  .title {
    height: 44px;
    padding: 0 20px;
    box-sizing: border-box;
    line-height: 40px;
    border-radius: 8px 8px 0px 0px;
    background: #fff;
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    background: url("../assets/img/titlePng.png") no-repeat;
    background-size: cover;
    .tLeft {
      height: 44px;
      display: flex;
      align-items: center;
      ::v-deep i {
        border: 1px solid #c8c9cc;
      }
      span {
        line-height: 31px;
        margin-left: 10px;

        font-size: 14px;
        color: #208fff;
        letter-spacing: 0;
        font-weight: 500;
      }
    }
  }
  > .contentbox {
    padding: 10px 14px 0 14px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    position: relative;
    margin-bottom: 10px;

    > div {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      // color: #777777;
      line-height: 28px;
      justify-content: space-between;
      // margin-top: 4px;

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      line-height: 20px;
      font-weight: 400;
      font-size: 14px;
      color: #7e7e7e;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 400;
    }
    img {
      position: absolute;
      width: 133px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .remark {
      position: relative;
      display: block;
      // align-items: flex-start;
      > span:nth-of-type(1) {
        width: 78px;
        align-items: flex-start;
        white-space: nowrap;
        font-size: 14px;
        color: #7e7e7e;
        letter-spacing: -0.2px;
        line-height: 28px;
        font-weight: 400;
        > span {
          color: transparent;
        }
      }
      > span:nth-of-type(2) {
        //float: right;
        position: absolute;
        top: 0;
        right:0;
        font-size: 14px;
        color: #464a4c;
        letter-spacing: -0.2px;
        line-height: 28px;
        font-weight: 400;

      }
      .remarkWord {
        margin-top: 4px;
        width: 305px;
        padding: 12px;
        background: #f8fcff;
        border-radius: 10px;
        letter-spacing: -0.2px;
        line-height: 20px;
        box-sizing: border-box;

        font-size: 14px;
        color: #7e7e7e;
        letter-spacing: -0.2px;
        line-height: 20px;
        font-weight: 400;
      }
    }
    .ctbox {
      // margin-bottom: 10px;
      line-height: 28px;
      align-items: flex-start;
      > span:nth-of-type(1) {
        width: 100px;
        word-break: break-all;

        font-size: 14px;
        color: #7e7e7e;
        letter-spacing: 0;
        line-height: 28px;
        font-weight: 400;
      }
      > span:nth-of-type(2) {
        // width: 180px;
        flex: 1;
        word-break: break-all;
        text-align: right;

        font-size: 14px;
        color: #464a4c;
        letter-spacing: 0;
        line-height: 28px;
        font-weight: 400;
      }
    }

    .money {
      > span:nth-of-type(2) {
        //
        // font-size: 16px;
        // color: #f46c6c;
        // letter-spacing: 0;
        // line-height: 20px;
        // font-weight: 500;

        font-size: 14px;
        color: #f46c6c;
        letter-spacing: 0;
        line-height: 28px;
        font-weight: 500;
      }
    }
  }
  .contentbox.free {
    background: url("../assets/img/refree.png") no-repeat;
    background-size: 108px 108px;
    background-position: 50% 26px;
  }
  .cu-form-group {
    border-top: 1px solid #eeeeee;
    width: 305px;
    margin: 0 auto;
    margin-top: 5px;
    display: flex;
    padding: 9px 0px;
    box-sizing: border-box;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    > div {

      background: #fff;
      //
      border-radius: 25px;
      margin-left: 15px;
      width: 88px;
      height: 26px;
      font-weight: 400;
      box-sizing: border-box;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      color: #208fff;
      border: 1px solid #208fff;

      // border:1px solid #208fff;
      letter-spacing: -1.3px;
      text-align: center;
      font-weight: 400;
      // font-size: 15px;
      // font-family: PingFangSC-Semibold, PingFang SC;
      // font-weight: 600;
      // color: #1989fa;
      // padding: 10px 0;
    }
  }
  .cu-form-gro {
    border-top: 1px solid #eeeeee;
    width: 305px;
    margin: 0 auto;
    margin-top: 5px;
    display: flex;
    padding: 9px 0px;
    box-sizing: border-box;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    > div {

      background: #fff;
      //
      border-radius: 25px;
      margin-left: 5px;
      width: 88px;
      height: 26px;
      font-weight: 400;
      box-sizing: border-box;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      color: #208fff;
      border: 1px solid #208fff;
      // border:1px solid #208fff;
      letter-spacing: -1.3px;
      text-align: center;
      font-weight: 400;
      // font-size: 15px;
      // font-family: PingFangSC-Semibold, PingFang SC;
      // font-weight: 600;
      // color: #1989fa;
      // padding: 10px 0;
    }
  }
}
.remark_special{
  width: 56px;
  display: flex;
  justify-content: space-between;
}
.model {
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.3;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
  overflow: hidden;
}

.content {
  text-align: center;
  padding: 15px 0;
  line-height: 24px;
}

.dialog {
  ::v-deep .van-field__label {
    width: 110px !important;
  }
}
</style>
